import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material'
import AnimateButton from 'components/@extended/AnimateButton'
import { TextField } from 'components/@extended/TextField'
import SingleOrganizationSelector from 'components/SingleOrganizationSelector'
import type { FC } from 'react'
import type { UserProfile } from 'types/user-profile'

interface EditOrganizationNameDialogProps {
  open: boolean
  organizationName: string
  parentId: string
  isRootOrganization: boolean
  isSubmitting: boolean
  userProfile: UserProfile
  onClose: () => void
  onConfirm: () => Promise<void>
  onNameChange: (name: string) => void
  onParentChange: (parentId: string) => void
}

const EditOrganizationNameDialog: FC<EditOrganizationNameDialogProps> = ({
  open,
  organizationName,
  parentId,
  isRootOrganization,
  isSubmitting,
  userProfile,
  onClose,
  onConfirm,
  onNameChange,
  onParentChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="edit-name-dialog-title" maxWidth="xs" fullWidth>
      <DialogTitle id="edit-name-dialog-title">Edit Team</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            type="text"
            variant="outlined"
            label="Team Name"
            shrink
            pill
            fullWidth
            value={organizationName}
            onChange={(e) => onNameChange(e.target.value)}
          />
        </Box>
        {!isRootOrganization && (
          <Box>
            <SingleOrganizationSelector
              userProfile={userProfile}
              selectedOrganizationId={parentId}
              handleChange={onParentChange}
              label="Select Parent Team"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ mb: 2, mx: 2 }}>
        <AnimateButton>
          <Button variant="contained" color="warning" onClick={onClose}>
            Cancel
          </Button>
        </AnimateButton>

        <Tooltip title="Update Team Name" arrow placement="top-start">
          <span>
            <AnimateButton>
              <Button variant="contained" color="primary" onClick={onConfirm} disabled={isSubmitting}>
                Update
              </Button>
            </AnimateButton>
          </span>
        </Tooltip>
      </DialogActions>
    </Dialog>
  )
}

export default EditOrganizationNameDialog
